import { createTheme } from '@mui/material';

const theme = createTheme();

export const MainTheme = createTheme({
    palette: {
        background: {
            toolbar: '#F5F5F5',
            tableHeader: '#F5F5F5',
            navbar: '#FAFBFB',
        },
        subtitle: '#999999',
    },
    typography: {
        fontSize: 14,
        body1: {
            fontSize: 14,
            fontWeight: 400,
        },
        body2: {
            fontSize: 14,
            fontWeight: 700,
        },
        // Вариант как body, но жирнее. Используется для заголовков секций и некоторых хидеров
        b1: {
            fontSize: 14,
            fontWeight: 700,
        },
    },

    components: {
        MuiPopper: {
            styleOverrides: {
                root: {
                    zIndex: '10000001 !important',
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                root: {
                    zIndex: '10000001 !important',
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    b1: 'div',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textDecoration: 'none !important',
                },
            },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'action' },
                    style: {
                        backgroundColor: '#F5F5F5',
                        color: '#344563',
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: '#EBEBEB !important',
                        },
                    },
                },
            ],
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontSize: '14px',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginRight: 0,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    zIndex: 10000000,
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                root: {
                    zIndex: 10000000,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
                MenuProps: {
                    PaperProps: {
                        style: {
                            maxHeight: '224px',
                            //width: 250,
                        },
                    },
                },
            },

        },
        MuiInputBase: {
            defaultProps: {
                title: '',
            },
            styleOverrides: {
                root: {
                    background: '#fff',
                    '& .Mui-disabled': {
                        background: '#f0f0f0',
                    },
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center',

                        '& .MuiSvgIcon-root': {
                            fontSize: '1.3rem',
                        },
                    },
                    '& .MuiListItemIcon-root': {
                        minWidth: '32px',
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    //fontSize: '1.3rem',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    //minWidth: '32px',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '16px',
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                slots: {
                    // paper: DialogWithCloseBtn,
                },
            },

        },
        MuiDialogContent: {
            defaultProps: {
                dividers: true,
            },
            styleOverrides: {
                root: {
                    padding: '16px',
                    width: '100%',
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: '6px',
                },
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: '',
                openText: '',
                closeText: '',
            },
        },
        // MuiTabs: {
        //     styleOverrides: {
        //         root: {
        //             borderBottom: '1px solid',
        //             borderColor: theme.palette.divider,
        //         },
        //     },
        // },
    },
});